import styled from 'styled-components'
import { LookButton, iconButtonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

const getTemplateColumns = props => {
  const count = props.count || 1

  if (count <= 5) return `repeat(${count}, 52px)`
  if (count % 2 !== 0 && count < 8) return 'repeat(4, 52px)'
  if (count % 2 === 0 && count <= 10) return `repeat(${count / 2}, 52px)`

  return 'repeat(5, 52px)'
}

export const Container = styled.div`
  width: 380px;
  min-height: 180px;
  background: linear-gradient(135deg, #FFEB99 0%, #FFF8DC 40%, #FFE066 60%, #FFD700 100%);
  box-shadow: 0px 2px 10px -6px #252525;
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 10px 15px;
  border-radius: 15px;
  overflow: hidden;
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
`

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  gap: 10px;
`

export const CardFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const SealsRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${props => getTemplateColumns (props)};
  align-self: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
  gap: 10px;
`

export const SealDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  p {
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    text-align: center;
  }
`

export const Seal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ completed }) => {
    return completed
      ? 'linear-gradient(135deg, #f8faff 0%, #e3f0ff 25%, #f9eaff 50%, #f9f7d9 75%, #fffbe6 100%)'
      : '#F7F7F7'
  }};
  border: ${({ completed }) => completed ? '2px solid #FFC100' : '1px solid #CCCCCC'};
  border-radius: 10px;
  width: 54px;
  height: 54px;
  color: #252525;
`

export const SealImage = styled.img`
  position: absolute;
  width: 36px;
  height: 36px;
  opacity: ${({ completed }) => completed ? 1 : 0};
`

export const InfoText = styled.p`
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
  text-align: left;
`

export const Button = styled(LookButton).attrs(iconButtonLook({ size: 'xss' }))`
  width: 25px;
  height: 25px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 20px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 0px;
`
